// Addon selection, qty stepper, updateTotalPrice and personalisation reveals
// were moved to assets/addon-section.js. This file now only handles
// non-addon concerns (swatch/scroll, cart submission, modal triggers, etc).

$(".prod-swatch-label").on("click", function () {
	setTimeout(function () {
		updateTotalPrice();
		if (!isBAB && $("#jars").length && $("#jars").is(":visible")) {$("html, body").animate({ scrollTop: $("#jars").offset().top - 50 }, 1000);}
		if (isBAB) {$("html, body").animate(
				{
					scrollTop: parseInt($(".posy-selection").offset().top - 200),
				},
				200
			);
                     $('.jar-item').removeClass('active');

                   }

		return false;
	}, 300);
});

$(window).on("load", function () {
	// Posy slider (BAB only) - retained; jar/addon Splide init lives in
	// addon-section.js and addon totals are recomputed there.
	if (window.innerWidth < 798) {
		$(".posy-selection .addon").flickity({
			contain: true,
			groupCells: true,
			draggable: true,
			pageDots: false,
			prevNextButtons: true,
		});
	}
});

function remove_bundle(bundle_prop, bundle_id) {
	var id_arry = {};
	$(".CartItem").each(function (e) {
		var all_prod_prop = $(this).find(".wc_custom_Custom_Bundle").data("prop");
		if (bundle_prop == all_prod_prop) {
			var cuurent_var_id = $(this).find(".cart-remove").data("id");
			console.log("cuurent_var_id", cuurent_var_id);
			id_arry[cuurent_var_id] = 0;
		}
	});
	$.ajax({
		type: "POST",
		url: "/cart/update.js",
		data: { updates: id_arry },
		dataType: "json",
		beforeSend: function () {},
		success: function (data) {
			ajaxCart.load();
		},
		error: function (error, textStatus) {},
	});
}

async function clearCart() {
	// console.log("clearing cart items....");
	try {
		window.location.href = window.Shopify.routes.root + "cart";
		return;
		await fetch(window.Shopify.routes.root + "cart/clear.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		});
		window.scrollTo(0, 0);
		// location.reload();
		addItemsToCart();
	} catch (error) {
		console.error(error);
	}
	// finally {
	//  window.scrollTo(0, 0);
	//  location.reload();
	// }
}

// Personalisation tag regexes - tag-based detection replaces the old
// hardcoded variant-ID switches so newly-activated personalised SKUs
// (e.g. the new Personalised Prosecco) are picked up automatically.
// Each regex requires a `product:` prefix + a TYPE-specific suffix so a
// generic product:personalised (used on jars) doesn't trigger candle or
// prosecco detection.
var RE_PERSO_CANDLE   = /product:personali[sz]edcandle/;
var RE_PERSO_PROSECCO = /product:(?:persoanli[sz]edbottle|personali[sz]edbottle|personali[sz]edprosecco)/;
var RE_PERSO_POLAROID = /product:(?:imageupload|personali[sz]edpolaroid)/;
var RE_PERSO_JAR      = /product:personali[sz]edjar/;

function addItemsToCart() {
	var input_val = $(".input-text.form-control").val();
	const personalizedCandleMessage =
		$(".personalized-input-container.candle #personalized_message").val() || "";
   const personalizedProseccoMessage =
		$(".personalized-input-container.prosecco #personalized_message").val() || "";
	const personalizedJarMessage =
		$(".personalized-input-container.jar #personalized_message").val() || "";

	if (input_val != "") {
		var $th_button = $(this);
		var $th_id_array = new Array();
		var prop_multi_id = [];
		jQuery(".addon-item.active").each(function (index, value) {
			var pro_id = $(this).data("id");
			// var $th_temQTY = '1';
			const $th_temQTY = $(this).find(".des .addon-qty-container input").val();
			var $th_temVID = pro_id;
			prop_multi_id.push($(this).data("id"));

			var proTags = ($(this).attr("data-tag") || "").toLowerCase();
			var lineItem = { variant_id: $th_temVID, quantity: $th_temQTY };

			if (RE_PERSO_PROSECCO.test(proTags)) {
				if (personalizedProseccoMessage) lineItem.properties = { Message: personalizedProseccoMessage };
			} else if (RE_PERSO_CANDLE.test(proTags)) {
				if (personalizedCandleMessage) lineItem.properties = { Message: personalizedCandleMessage };
			} else if (RE_PERSO_JAR.test(proTags)) {
				if (personalizedJarMessage) lineItem.properties = { Message: personalizedJarMessage };
			}

			lineItem.properties = Object.assign(
				lineItem.properties || {},
				window.CustomAbAddon?.propertiesFor(this)
			);


			$th_id_array.push(lineItem);
		});
		$th_id_array.reverse();
		var properties_multi_list = prop_multi_id.join("-");
		var form_id = $(".shopify-product-form").attr("id");

		function bundle_addtocart() {
			if ($th_id_array.length > 0) {
				var $th_request = $th_id_array.shift();
				var $th_tempId = $th_request.variant_id;
				var $th_tempQTY = $th_request.quantity;

				console.log("properties_multi_list", properties_multi_list);
                
				var data = {
					id: $th_tempId,
					quantity: $th_tempQTY,
				};

				if ($th_request.properties != undefined) {
					data.properties = $th_request.properties;
				}
				// Variant-ID-keyed overrides removed - the tag-based detection
				// in addItemsToCart's iteration already sets $th_request.properties
				// for every personalised product (candle / prosecco / jar /
				// polaroid), including the new Personalised Prosecco SKU whose
				// variant ID isn't one of the four legacy hardcoded constants.

				var $th_ajax_without_properties = {
					type: "POST",
					url: "/cart/add.js",
					data: data,
					dataType: "json",
					beforeSend: function () {
						$th_button.addClass("processing");
						$th_button.attr("disabled", true);
					},
					success: function (cart) {
						bundle_addtocart();
					},
					error: function (XMLHttpRequest, textStatus) {
						$th_button.children("span.button_text").text("Error");
						console.log(XMLHttpRequest);
					},
				};
				$.ajax($th_ajax_without_properties);
			} else {
				window.location.href = "/cart";
			}
		}
		setTimeout(function () {
			$.ajax({
				type: "POST",
				url: "/cart/add.js",
				dataType: "json",
				data: $("#" + form_id).serialize(),
				success: function (sucess) {
					bundle_addtocart();
				},
				error: function (error) {},
			});
		}, 300);
	}
    else {
		$(".input-text.form-control").addClass("active-error");
		console.log("Here it suppose to scroll");
		$("html, body").animate(
			{
				scrollTop: parseInt($(".perdonalise-cover").offset().top - 300),
			},
			100
		);
		return false;
	}
  
}

$(document).on("click", ".global-button", async function (e) {
	e.preventDefault();
    $(".cimagemessage").hide();
	const personalizedCandleMessage =
		$(".personalized-input-container.candle #personalized_message").val() || "";
	let hasPersonalizedCandle = false;
	const personalizedJarMessage =
		$(".personalized-input-container.jar #personalized_message").val() || "";

	const personalizedProseccoMessage =
		$(".personalized-input-container.prosecco #personalized_message").val() || "";	
		
	let hasPersonalizedJar = false;
	let hasSelectedAJar = document.querySelectorAll("#jars .addon-item.active")
		.length
		? true
		: false;
	const hasSelectedPosy = document.querySelectorAll(".posy-selection .addon-item.active")
		.length
		? true
		: false;

	const freePostcardSection = document.querySelector(".free-postcard-selection");

	if (freePostcardSection) {
		const handleSelectedSleeves =
			freePostcardSection.querySelectorAll(".addon-item.active").length > 0;

		if (!handleSelectedSleeves) {
			Swal.fire({
			title: "Oops...",
			width: 700,
			html: "Please select a sleeve to proceed.",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
			}).then(() => {
			$("html, body").animate(
				{
				scrollTop:
					parseInt($(".free-postcard-selection").offset().top - 200),
				},
				200
			);
			});
			return;
		}
	}
	
	if (!hasSelectedPosy && isBAB) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html: "Please select a posy to proceed.",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		}).then((result) => {
			$("html, body").animate(
				{
					scrollTop: parseInt($(".posy-selection").offset().top - 200),
				},
				200
			);
		});
		return;
	}

	if (!hasSelectedAJar && hasJarCollection && !isBAB) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html: "Please select a free jar quote to proceed.",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		}).then((result) => {
			$("html, body").animate(
				{
					scrollTop: parseInt($("#jars").offset().top - 200),
				},
				200
			);
		});
		return;
	}

	// Detect personalised addons by tile data-tag (regex, not hardcoded IDs)
	// so new personalised SKUs pick up validation without a code change.
	let hasPersonalizedProsecco = false;
	jQuery(".addon-item.active").each(function () {
		var tags = ($(this).attr("data-tag") || "").toLowerCase();
		if (RE_PERSO_CANDLE.test(tags))   hasPersonalizedCandle  = true;
		if (RE_PERSO_PROSECCO.test(tags)) hasPersonalizedProsecco = true;
		if (RE_PERSO_JAR.test(tags))      hasPersonalizedJar     = true;
	});

	if (hasPersonalizedJar && !personalizedJarMessage) {
		Swal.fire({
			title: "Oops...",
			width: 700,
			html: "It seems you have selected personalised jar, please make sure you have provide the name, nickname or message you want to appear on the jar",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		});
		return;
	}

	if (hasPersonalizedCandle && !personalizedCandleMessage) {
		Swal.fire({
			title: "Oops...",
			width: 700,
			html: "It seems you have selected personalised candle, please make sure you have provide the name, nickname or message you want to appear on the candle",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		});
		return;
	}

	if (hasPersonalizedProsecco && !personalizedProseccoMessage) {
		Swal.fire({
			title: "Oops...",
			width: 700,
			html: "It seems you have selected personalised prosecco, please make sure you have provide the name, nickname or message you want to appear on the bottle",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		}).then(function () {
			$("html, body").animate({
				scrollTop: parseInt($(".personalized-input-container.prosecco").offset().top - 200, 10)
			}, 200);
			$(".personalized-input-container.prosecco input").trigger("focus");
		});
		return;
	}

	// only allow user to select one main product
	// fetch cart item and check from there
	// start - blocking if cart already has a flower product
	const data = await fetch(window.Shopify.routes.root + "cart.js");
	const cartItems = await data.json();
	let itemCount = cartItems.items.reduce((count, item) => {
		if (
			!item.product_type ||
			item.product_type === "Bundle" ||
			item.product_type === "BAB" ||
			item.product_type === "Gift Cards"
		) {
			return count + item.quantity;
		} else {
			return count;
		}
	}, 0);

	console.log(itemCount);

	if (itemCount >= 12) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html:
				"Oops, you can only check out with 12 main product in your cart at a time.<br><br>" +
				"Please proceed to your cart and checkout first before placing a second order, or you can clear cart below.<br><br>" +
				'For bulk or corporate gifting you can head to our dedicated <a href="https://lvlycorporate.com.au/"><strong>Corporate website</strong></a>.<br><br>',
			confirmButtonColor: "#ee4382",
			cancelButtonColor: "#383c4f",
			confirmButtonText: "Clear Cart",
			showCancelButton: true,
		}).then(async (result) => {
			if (result.isConfirmed) {
				// clear cart
				await clearCart();
			}
		});
		return;
	}



    //Check if Polaroid photo upload
      if($(".product-addons-cover .personalised-upload-cover").length){
        let firstInvalid = null;

		$('[data-ph-fieldname]:visible').each(function () {
			const $f = $(this);
			const isPhoto = $f.find('.uploadcare--widget, [id^="previewImages_"]').length > 0;
			if (!isPhoto) return;

			const uploaded =
				$f.find('[id^="previewImages_"]').children().length > 0 ||
				$f.find('.uploadcare--widget[data-status="loaded"]').length > 0 ||
				$f.find('[data-prev-id]').length > 0;

			if (!uploaded && !firstInvalid) firstInvalid = $f;
		});

		if (firstInvalid) {
			const label = (firstInvalid.attr('data-ph-fieldname') || 'this field').trim();
			Swal.fire({
				title: "Oops...",
				width: 700,
				html: 'Please upload your photo for "' + label + '" before continuing.',
				confirmButtonColor: "#ee4382",
				confirmButtonText: "Ok",
			}).then(function () {
				$("html, body").animate({
					scrollTop: parseInt(firstInvalid.offset().top - 200, 10)
				}, 200);
			});
			return;
		}
      }
    //Check if Polaroid photo upload end 

  
	// end - blocking if cart already has a flower product
	addItemsToCart();
});

$(document).keyup(function (event) {
	$(".input-text.form-control").removeClass("active-error");
});

// "See more" popup lives in assets/ab-product-popup.js (data-ab-product-popup).

